// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"SearchInput_searchInputWrapper__lLeLy","searchButton":"SearchInput_searchButton__4MDy+"};